export const LARGE_MARKMAP_NODE_THRESHOLD = 60;
export const LARGE_MARKMAP_INITIAL_EXPAND_LEVEL = 3;

export const countMarkmapNodes = (node) => {
  if (!node) return 0;
  return 1 + (node.children || []).reduce(
    (total, child) => total + countMarkmapNodes(child),
    0
  );
};

export const getMarkmapRenderPlan = (root, prefersReducedMotion = false) => {
  const nodeCount = countMarkmapNodes(root);
  const isLarge = nodeCount > LARGE_MARKMAP_NODE_THRESHOLD;

  return {
    nodeCount,
    initialExpandLevel: isLarge ? LARGE_MARKMAP_INITIAL_EXPAND_LEVEL : -1,
    animateReveal: !isLarge && !prefersReducedMotion,
  };
};